import HomePage from './views/Home';
import Desc1Page from './views/Desc1';
import Desc2Page from './views/Desc2';
import MenuPage from './views/Menu';
import AircraftIntroPage from './views/AircraftIntro';
import AircraftFixPage from './views/AircraftFix';
import GameDescPage from './views/GameDesc';
import GamePage from './views/Game';
import ResultPage from './views/Result';
import IntroPage from './views/Intro';

export default [
    { name: 'home-page', path: '/', exact: true, Component: HomePage },
    { name: 'desc1-page', path: '/desc1', Component: Desc1Page },
    { name: 'desc2-page', path: '/desc2', Component: Desc2Page },
    { name: 'menu-page', path: '/menu', Component: MenuPage }, 
    { name: 'aircraft-intro-page', path: '/aircraft-intro', Component: AircraftIntroPage },
    { name: 'aircraft-fix-page', path: '/aircraft-fix', Component: AircraftFixPage },
    { name: 'game-desc-page', path: '/game-desc', Component: GameDescPage },
    { name: 'game-page', path: '/game', Component: GamePage },
    { name: 'result-page', path: '/result', Component: ResultPage },
    { name: 'intro-page', path: '/intro', Component: IntroPage }
];